import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["platformSelect", "channelIdField"]

  platformChanged() {
    const isYouTube = this.platformSelectTarget.value === "youtube"
    this.channelIdFieldTarget.classList.toggle("hidden", !isYouTube)
  }
}
